import styled from "styled-components";
import { Box, Button } from "grommet";
import encodedDiseases from "../../task-specific/initializations/examples.json";
import { useMemo } from "react";

const StyledButton = styled(Button)`
  font-size: 12px;
  padding: 0 8px 1px;
  text-align: center;
  border-radius: 5px;
`;

export interface EncodingPresetsProps {
  onSlidersChange(updatedSliderValues: number[]): void;
}

export function EncodingPresets({ onSlidersChange }: EncodingPresetsProps): React.ReactElement {
  const indices = useMemo(() => [...Array(32).keys()], []);

  return (
    <Box overflow={{ vertical: "scroll" }}>
      <Box gap="6px">
        {encodedDiseases.map((encodedDisease: any) => {
          return (
            <Box height={{ min: "30px" }}>
              <StyledButton
                key={encodedDisease.name}
                label={encodedDisease.name}
                onClick={() => {
                  const updatedSliderValues = indices.map((key) => Number(encodedDisease[String(key)]));
                  onSlidersChange(updatedSliderValues);
                }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
